import React from 'react';

import { toSxArray } from '_lib/utils/helpers';

import { Button, ButtonProps } from '../Button/Button';

export type DialogButtonProps = ButtonProps;

export const DialogButton = (props: DialogButtonProps) => {
  const { sx, ...restOfProps } = props;
  return <Button sx={[{ textTransform: 'none' }, ...toSxArray(sx)]} variant='contained' {...restOfProps} />;
};
